import { BookingInfo } from '@models/booking-info.model';
import { TranslateModule } from '@ngx-translate/core';
import { format, isValid } from 'date-fns';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-booking-info',
  standalone: true,
  imports: [CommonModule, TranslateModule, TooltipModule],
  template: `
    <div
      class="booking-info flex w-32 cursor-pointer flex-col gap-1"
      (click)="navigateToBooking()"
      [pTooltip]="'common.viewDetails' | translate"
    >
      <!-- Booking name is always visible -->
      <div class="font-medium">{{ bookingInfo.name }}</div>

      <!-- Dates are conditionally visible -->
      @if (showDates && bookingInfo.hasDates()) {
        <div class="flex items-start gap-1 text-sm text-gray-600 dark:text-gray-400">
          <i class="pi pi-calendar mt-1 mr-1"></i>
          <span>{{ formatDateRange(bookingInfo.startDate, bookingInfo.endDate) }}</span>
        </div>
      }
    </div>
  `
})
export class BookingInfoComponent {
  @Input({ required: true }) bookingInfo!: BookingInfo;
  @Input() showDates: boolean = true;

  constructor(private router: Router) {}

  /**
   * Navigate to booking detail page
   */
  navigateToBooking(): void {
    if (this.bookingInfo && this.bookingInfo.id) {
      this.router.navigate(['/bookings', this.bookingInfo.id]);
    }
  }

  /**
   * Format date range for display
   * @param startDate Start date
   * @param endDate End date
   * @returns Formatted date range string
   */
  formatDateRange(startDate?: Date, endDate?: Date): string {
    if (!startDate || !endDate || !isValid(startDate) || !isValid(endDate)) {
      return '';
    }

    const formattedStart = format(startDate, 'yyyy-MM-dd');
    const formattedEnd = format(endDate, 'yyyy-MM-dd');

    return `${formattedStart} – ${formattedEnd}`;
  }
}
